import { render, staticRenderFns } from "./SignEmbeddedDialog.vue?vue&type=template&id=f2b0b750&scoped=true"
import script from "./SignEmbeddedDialog.vue?vue&type=script&lang=js"
export * from "./SignEmbeddedDialog.vue?vue&type=script&lang=js"
import style0 from "./SignEmbeddedDialog.vue?vue&type=style&index=0&id=f2b0b750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b0b750",
  null
  
)

export default component.exports